import React from "react";

import {DeleteOutlined} from "@ant-design/icons";
import {Button, message, Popconfirm, Tooltip} from "antd";

import api from "../../api";
import {extractErrorMessage} from "../../index";

export const ButtonDeleteRecommendation = ({projectId, record, onDeleteSuccess}) => {
	const handleDelete = async () => {
		const recommendationId = record._id;

		if (!recommendationId) {
			console.error("Delete failed: The recommendation record is missing an _id.", record);
			message.error("Cannot delete: Invalid recommendation ID.");
			return;
		}

		message.loading({content: "Deleting recommendation...", key: "deleteRec"});
		try {
			const apiUrl = `/projects/${projectId}/material-analysis/user-recommendations/${recommendationId}`;
			await api.delete(apiUrl, {omitGlobalError: true});

			message.success({content: "Recommendation deleted successfully!", key: "deleteRec", duration: 2});

			if (onDeleteSuccess) {
				onDeleteSuccess();
			}
		} catch (error) {
			console.error("Failed to delete recommendation:", error.response || error);
			const errorMsg = await extractErrorMessage(error);
			message.error({content: errorMsg, key: "deleteRec", duration: 4});
		}
	};

	return (
		<Popconfirm
			title="Are you sure you want to delete this recommendation?"
			onConfirm={handleDelete}
			okText="Yes, Delete"
			cancelText="No">
			<Button
				danger
				icon={
					<Tooltip title="Delete user recommendation">
						<DeleteOutlined />
					</Tooltip>
				}
			/>
		</Popconfirm>
	);
};

export default ButtonDeleteRecommendation;
